import {
  Alert,
  Box,
  Button,
  Card,
  CircularProgress,
  FormControl,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import moment from 'moment';
import { HeaderHeight, PageHeaderHeight } from '../Constants';
import { DeleteVersion, GetFotaLogs, GetVersionList } from '../network/Fota';
import NoDataAvailable from './_dashboard/smartlock/NoDataAvailable';
import { useAuth } from './customContextProviders/AuthContext';
import AddNewVersion from './_dashboard/smartlock/AddNewVersion';
import ConfirmAlertDialog from './ConfirmDialog';

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  },
  tableCellStyle: {
    fontSize: {
      xs: '12px',
      md: '14px'
    },
    fontWeight: 700,
    padding: {
      xs: '8px',
      md: '16px'
    },
    textWrap: 'nowrap',
    backgroundColor: '#FFFFFF'
  },
  tablePaper: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF'
  },
  tableContainer: {
    flexGrow: 1,
    height: `calc(100vh - ${HeaderHeight + PageHeaderHeight + 56 + 40 + 50 + 18}px)`,
    overflow: 'auto'
  }
}));

const LoaderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50px'
});
const PageHeader = styled('Box')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 1,
  flexDirection: 'row !important',
  height: PageHeaderHeight
}));

export default function FOTAMagement() {
  const classes = useStyles();
  const { sessionUserData } = useAuth();

  const userRole = sessionUserData?.user?.userRole?.roleName;

  const [deviceLogs, setDeviceLogs] = useState([]);
  const [fotaVersionList, setFotaVersionList] = useState([]);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [filterOrganization, setFilterOrganization] = useState('');
  const [isAssignAddModal, setIsAssignAddModal] = useState(false);
  const [selectedFotaData, setSelectedFotaData] = useState(null);
  const [openConfirmAlertDialog, setOpenConfirmAlertDialog] = useState(false);
  const [confirmAlertDialogMetas, setConfirmAlertDialogMetas] = useState({
    message: '',
    title: '',
    positiveBtnLable: '',
    negativeBtnLabel: ''
  });
  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });
  const vertical = 'bottom';
  const horizontal = 'left';

  const handleFotaMoreMenuClick = (action, data) => {
    switch (action) {
      case 'edit_fota_version': {
        setSelectedFotaData(data);
        setIsAssignAddModal(true);
        break;
      }
      case 'delete_fota': {
        setSelectedFotaData(data);
        setConfirmAlertDialogMetas({
          ...confirmAlertDialogMetas,
          message: 'Are you sure want to delete this fota ?',
          title: 'Delete',
          positiveBtnLable: 'Confirm',
          negativeBtnLabel: 'Cancel'
        });
        setOpenConfirmAlertDialog(true);
        break;
      }
      default:
        return '';
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const onAddFotaModalAction = (d) => {
    getFotaVersionList();
  };

  const getFotaVersionList = async () => {
    try {
      setLoader(true);
      const res = await GetVersionList();
      setLoader(false);
      setFotaVersionList(res?.data);
    } catch (error) {
      setLoader(false);
      console.error(error, 'Error fetching FOTA versions');
    }
  };

  const deleteFotaVerisonById = async (verisonId) => {
    try {
      const res = await DeleteVersion(verisonId);

      if (res) {
        setSelectedFotaData(null);
        setAlertMetas({
          ...alertMetas,
          severity: 'success',
          snackBarOpened: true,
          msg: 'Fota version Deleted!'
        });
        setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
        getFotaVersionList();
      }
    } catch (error) {
      setSelectedFotaData(null);
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message || 'Failed to delete fota.'
      });
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    }
  };

  useEffect(() => {
    getFotaVersionList();
  }, []);

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>
      <Card sx={{ width: '100%', padding: '10px' }}>
        <Box>
          <PageHeader>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
              <Button
                variant="outlined"
                size="medium"
                onClick={() => setIsAssignAddModal(true)}
                sx={{ backgroundColor: '#FFFFFF' }}
              >
                Add Version
              </Button>
            </Stack>

            {/* <FormControl size="small" sx={{ minWidth: { xs: 130, sm: 150 } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography sx={{ fontSize: { xs: '12px', sm: '14px' }, fontWeight: 600 }}>
                  Filter By
                </Typography>
                <Select
                  sx={{
                    fontSize: { xs: '12px', sm: '14px' },
                    fontWeight: '500',
                    minWidth: '130px',
                    borderRadius: '12px'
                  }}
                  labelId="role-filter-select-label"
                  id="role-filter-select"
                  value={filterOrganization}
                  onChange={handleFilterChange}
                  IconComponent={ExpandMoreIcon}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 180,
                        overflowY: 'auto'
                      }
                    }
                  }}
                >
                  {fotaVersionList?.data?.map((item) => (
                    <MenuItem
                      value={item?.id}
                      key={item?.id}
                      className={classes.menuItem}
                      sx={{ textTransform: 'capitalize' }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          gap: '10px',
                          width: '100%',
                          justifyContent: 'space-between'
                        }}
                      >
                        {item?.name}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </FormControl> */}
          </PageHeader>
          <Box sx={{ width: '100%', typography: 'body1', borderTop: '1px solid #EBEBEB' }}>
            <Paper className={classes.tablePaper}>
              <TableContainer className={classes.tableContainer}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.tableCellStyle} width={100}>
                        Name
                      </TableCell>
                      <TableCell className={classes.tableCellStyle} width={100}>
                        Version
                      </TableCell>
                      <TableCell className={classes.tableCellStyle} width={100}>
                        Created At
                      </TableCell>
                      <TableCell className={classes.tableCellStyle} width={500}>
                        Description
                      </TableCell>
                      <TableCell className={classes.tableCellStyle} width={100}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fotaVersionList?.data?.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={10}>
                          <NoDataAvailable />
                        </TableCell>
                      </TableRow>
                    )}
                    {loader ? (
                      <TableRow>
                        <TableCell colSpan={10}>
                          <LoaderContainer>
                            <CircularProgress size={30} />
                          </LoaderContainer>
                        </TableCell>
                      </TableRow>
                    ) : (
                      fotaVersionList?.data?.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell
                            align="left"
                            sx={{
                              textTransform: 'capitalize',
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                          >
                            {item?.name}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                            align="left"
                          >
                            {item?.version}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                            align="left"
                          >
                            {moment(item?.createdAt).format('DD-MM-YYYY hh:mm:ss')}
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              textTransform: 'capitalize',
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px' // Larger screens
                              }
                            }}
                          >
                            {item?.details}
                          </TableCell>
                          <TableCell
                            sx={{
                              minWidth: '5vw',
                              textWrap: 'nowrap',
                              textTransform: 'capitalize',
                              padding: {
                                xs: '8px',
                                md: '16px'
                              },
                              fontSize: {
                                xs: '12px',
                                md: '14px'
                              }
                            }}
                            align="left"
                          >
                            <Tooltip title="Edit" placement="top">
                              <IconButton
                                data-testid="edit-fota-button"
                                onClick={() => handleFotaMoreMenuClick('edit_fota_version', item)}
                              >
                                <BorderColorOutlinedIcon
                                  sx={{ fontSize: { xs: '18px', md: '24px' } }}
                                />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete" placement="top">
                              <IconButton
                                data-testid="delete-fota-button"
                                onClick={() => handleFotaMoreMenuClick('delete_fota', item)}
                              >
                                <DeleteOutlineOutlinedIcon
                                  sx={{ color: '#C30A0A', fontSize: { xs: '18px', md: '24px' } }}
                                />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
            {fotaVersionList?.data?.length !== 0 && (
              <Stack
                sx={{
                  marginTop: '10px',
                  marginBottom: '10px'
                }}
              >
                <Pagination
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                  count={fotaVersionList?.totalPages}
                  showFirstButton
                  showLastButton
                  onChange={handlePageChange}
                  page={page}
                  total={fotaVersionList?.total}
                />
              </Stack>
            )}
          </Box>
        </Box>
      </Card>
      {isAssignAddModal && (
        <AddNewVersion
          openAssignedModal={isAssignAddModal}
          setIsAssignAddModal={setIsAssignAddModal}
          setAlertMetas={setAlertMetas}
          alertMetas={alertMetas}
          onAction={(d) => onAddFotaModalAction(d)}
          selectedFotaData={selectedFotaData}
          setSelectedFotaData={setSelectedFotaData}
        />
      )}

      <ConfirmAlertDialog
        openConfirmAlertDialog={openConfirmAlertDialog}
        message={confirmAlertDialogMetas?.message}
        title={confirmAlertDialogMetas?.title}
        positiveBtnLable={confirmAlertDialogMetas?.positiveBtnLable}
        negativeBtnLable={confirmAlertDialogMetas?.negativeBtnLabel}
        handleClose={() => setOpenConfirmAlertDialog(false)}
        handlePositiveClose={() => {
          deleteFotaVerisonById(selectedFotaData?.id);
          setOpenConfirmAlertDialog(false);
        }}
        handleNegativeClose={() => setOpenConfirmAlertDialog(false)}
      />
    </Box>
  );
}
